import { FC, useState } from 'react';
import { useDebounce } from 'react-use';

import { GeneralSelector } from '../GeneralSelector/GeneralSelector';
import { useCustomers } from './CustomerSelector.hooks';
import { CustomerSelectorProps } from './CustomerSelector.types';

export const CustomerSelector: FC<CustomerSelectorProps> = (props) => {
    const { cellProps, disabled } = props;

    const [query, setQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState('');
    const { customers, isLoading } = useCustomers(debouncedQuery);

    useDebounce(() => setDebouncedQuery(query), 500, [query]);

    return (
        <GeneralSelector
            name='customer'
            items={customers}
            progress={isLoading}
            onInputChange={setQuery}
            cellProps={cellProps}
            disabled={disabled}
        />
    );
};

CustomerSelector.displayName = 'CustomerSelector';
